import { useEffect, useRef, memo } from 'react';
import { useMap } from '@vis.gl/react-google-maps';

const Polyline = memo(({ path, options, icons }) => {
    const map = useMap();
    const polylineRef = useRef(null);

    useEffect(() => {
        if (!map || !path) return;

        // Create the polyline
        const polylineOptions = {
            path: path,
            strokeColor: options?.strokeColor || '#FF0000',
            strokeOpacity: options?.strokeOpacity !== undefined ? options.strokeOpacity : 1.0,
            strokeWeight: options?.strokeWidth || 2,
            icons: icons,
            map: map
        };

        polylineRef.current = new google.maps.Polyline(polylineOptions);

        // Cleanup function
        return () => {
            if (polylineRef.current) {
                polylineRef.current.setMap(null);
                polylineRef.current = null;
            }
        };
    }, [map, path, options, icons]);

    return null;
});

Polyline.displayName = 'Polyline';

export default Polyline;
